import type { ComponentChildren, CSSProperties } from 'preact'

import { floatingPanelBaseStyle } from '#src/assets/ui/shared/styles.ts'

export function FloatingPanel({
  visible,
  maxWidth,
  className,
  style,
  children,
}: {
  visible: boolean
  maxWidth: string
  className?: string
  style?: CSSProperties
  children: ComponentChildren
}) {
  return (
    <div
      className={className}
      style={{
        ...floatingPanelBaseStyle,
        maxWidth,
        opacity: visible ? '1' : '0',
        visibility: visible ? 'visible' : 'hidden',
        pointerEvents: visible ? 'auto' : 'none',
        transform: visible ? 'translateY(0)' : 'translateY(1.6em)',
        ...style,
      }}
    >
      {children}
    </div>
  )
}
